import React from 'react';
import RadioSelect from '../../../FormElements/RadioSelect/RadioSelect';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';

function DownlightOptic(props) {

  const {configuration,createItem,setNextEnabled} = props;

  function handleChange(event, value) {
    setNextEnabled(true);
    createItem({id:"downlightOptic",value:value});
  }

  return (
    <RadioGroup
      aria-label="Downlight Optic"
      name="downlightOptic"
      onChange={handleChange}
      defaultValue={configuration["downlightOptic"] ? configuration["downlightOptic"] : ''}
    >
    <Grid container spacing={3}>
      <Grid item xs={4}>
        <RadioSelect value="L" label="Lambertian (Standard Optic)"/>
      </Grid>
      {(configuration.mountingOptions !== "WD" && configuration.mountingOptions !== "WI") ?
        <Grid item xs={4}>
          <RadioSelect value="W" label="Wall Wash (Asymmetric Optic)"/>
        </Grid>
        :
        <Grid item xs={4}>
          <RadioSelect value="W" disabled={true} label="Wall Wash (Asymmetric Optic)"/>
        </Grid>
      }
    </Grid>
    {/* <p className="instructions">*Standard Optic.</p> */}
    {/* <p className="subsequent-instructions">**Asymmetric Optic.</p> */}
    </RadioGroup>
  );
}

export default DownlightOptic;